// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__2AA3Y","alertText":"style_alertText__3gXi-","action":"style_action__2Gmnc","overlay":"style_overlay__3CCoH"};